import * as React from "react";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import ProfileImage from "../ui/Avatar";
import PageHeader from "../ui/PageHeader";
import ChangePassword from "./ChangePassword";
import TwoFactorSettings from "../twoFactor/TwoFactorSettings";
import { brand } from "../theme";

function Field({ label, value }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography sx={{ fontWeight: 550, wordBreak: "break-word" }}>{value || "—"}</Typography>
    </Box>
  );
}

export default function UserAccountPage() {
  const user = JSON.parse(secureLocalStorage.getItem("profile") || "null")?.results || {};
  const joined = user.createdAt ? moment(user.createdAt) : null;

  return (
    <Box>
      <PageHeader title="Settings" subtitle="Your profile and sign-in security." />
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent sx={{ textAlign: "center", py: 4 }}>
              <Box sx={{ display: "inline-block", mb: 1.5 }}>
                <ProfileImage size={88} />
              </Box>
              <Typography variant="h6">
                {user.firstName} {user.lastName}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {user.email}
              </Typography>
              <Stack direction="row" gap={1} justifyContent="center" flexWrap="wrap" sx={{ mt: 2 }}>
                {user.risk_manager && <Chip size="small" color="secondary" variant="outlined" label={user.risk_manager} />}
                {user.branch && <Chip size="small" variant="outlined" label={user.branch} />}
              </Stack>
            </CardContent>
            <Divider />
            <CardContent>
              <Stack gap={1.75}>
                <Field label="First name" value={user.firstName} />
                <Field label="Last name" value={user.lastName} />
                <Field label="Role" value={user.userRole} />
                <Field
                  label="Member since"
                  value={joined ? `${joined.format("DD MMM YYYY")} (${joined.fromNow()})` : ""}
                />
              </Stack>
              <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 2.5 }}>
                To change these details, ask your system administrator.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={8}>
          <Stack gap={2.5}>
            <Card>
              <CardHeader title="Password" subheader="Change the password you use for all bank apps." titleTypographyProps={{ variant: "h6" }} subheaderTypographyProps={{ variant: "body2" }} />
              <Divider />
              <CardContent>
                <ChangePassword />
              </CardContent>
            </Card>
            <Box
              sx={{
                "& .tf-panel--card": {
                  maxWidth: "none",
                  margin: 0,
                  boxShadow: "none",
                  borderColor: brand.border,
                  borderRadius: "12px",
                  padding: "20px 24px",
                },
              }}
            >
              <TwoFactorSettings />
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
